<template>
    <div class="morph">
        <div class="confirm_wrap" v-if="userStore.info.cancel">
            <div class="grey_border">
                <div class="title success">Отмена заказа</div>
                <div class="case">
                    Заказ отменен
                    <div class="buttons_wrap">
                        <div @click="route_to('Orders')" class="button_simple b_blue">К заказам</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="confirm_wrap" v-if="userStore.info.confirm">
            <div class="grey_border">
                <div class="title qestion">Отмена заказа</div>
                <div class="case">
                    Вы уверены что хотите отменить заказ ?
                    <div class="buttons_wrap">
                        <div @click="confirm_set" class="button_simple b_blue">Назад</div>
                        <div @click="remove_order" class="button_simple b_blue">Отменить</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="userStore.info.is_loading" class="o_info_loading">
            <loading></loading>
        </div>
        <div v-if="userStore.info.show && !userStore.info.is_loading" class="order_info_wrap">
            <div v-if="userStore.info.error" class="o_info_error">
                <div class="grey_border">
                    <div class="title important_red">Ошибка</div>
                    <div class="case">
                        <p>Ошибка при получение данных заказа</p>
                        <p>Возможно заказ был отменен</p>
                        <p>Перезагрузите страницу или вернитесь к <span @click="update_orders(); route_to('Orders')" class="psevdo_link">списку заказов</span></p>
                    </div>
                </div>
            </div>
            <div v-else class="order_info">
                <!--        <div class="title">Ваш заказ {{userStore.info.data.order_num}}</div>-->
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.order_num }} от {{ userStore.info.data.order_date }}</div>
                    <div class="label">Номер</div>
                </div>
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.order_state }}</div>
                    <div class="label">Статус</div>
                </div>
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.address }}</div>
                    <div class="label">Адрес доставки</div>
                </div>
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.delivery_date }}</div>
                    <div class="label">Желательная дата отгрузки</div>
                </div>
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.payform }}</div>
                    <div class="label">Форма оплаты</div>
                </div>
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.contact }}</div>
                    <div class="label">Контактное лицо</div>
                </div>
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.phone }}</div>
                    <div class="label">Телефон</div>
                </div>
                <div class="row_w_label">
                    <div class="row">{{ userStore.info.data.order_comment }}</div>
                    <div class="label">Комментарий</div>
                </div>

                <div class="wrapper">
                    <div class="Rtable Rtable--7cols Rtable--collapse">
                        <div class="Rtable-row Rtable-row--head">
                            <div class="Rtable-cell title-cell column-heading">Наименование</div>
                            <div class="Rtable-cell articul-cell column-heading">Артикул</div>
                            <div class="Rtable-cell price-cell column-heading">Цена</div>
                            <div class="Rtable-cell countui-cell column-heading">Кол-во</div>
                            <div class="Rtable-cell summa-cell column-heading">Сумма</div>
                            <div class="Rtable-cell status-cell column-heading">Статус</div>
                            <div class="Rtable-cell actions-cell column-heading"></div>
                        </div>
                        <div class="row Rtable-row" v-for="(item, index) in userStore.info.data.items" :key="index">
                            <div class="Rtable-cell title-cell">
                                <div class="Rtable-cell--heading">Наименование</div>
                                <div class="Rtable-cell--content title-content">{{ item.item_name }}</div>
                            </div>
                            <div class="Rtable-cell articul-cell">
                                <div class="Rtable-cell--heading">Артикул</div>
                                <div class="Rtable-cell--content articul-content">{{ item.cae }}</div>
                            </div>
                            <div class="Rtable-cell price-cell">
                                <div class="Rtable-cell--heading">Цена</div>
                                <div class="Rtable-cell--content price-content">{{ item.price }}</div>
                            </div>
                            <div class="Rtable-cell countui-cell">
                                <div class="Rtable-cell--heading">Кол-во</div>

                                <div class="Rtable-cell--content countui-content">

                                    <div class="add_ui" v-if="!item.lock">
                                        <div class="added">{{ item.count }}</div>
                                        <div @click="change_count(index,item.count, true, 4)" class="set button">+4</div>
                                        <div @click="change_count(index,item.count, true, 1)" class="plus button">+1</div>
                                        <div @click="change_count(index,item.count, false, 1)" class="minus button">-1</div>
                                    </div>

                                    <div class="" v-else>
                                        <div class="added">{{ item.count }}</div>
                                    </div>

                                </div>

                            </div>
                            <div class="Rtable-cell summa-cell">
                                <div class="Rtable-cell--heading">Сумма</div>
                                <div class="Rtable-cell--content summa-content">{{ item.sum }}</div>
                            </div>
                            <div class="Rtable-cell status-cell">
                                <div class="Rtable-cell--heading">Статус</div>
                                <div class="Rtable-cell--content status-content">{{ item.state }}</div>
                            </div>
                            <div class="Rtable-cell actions-cell">
                                <div class="Rtable-cell--heading">Операции</div>
                                <div class="Rtable-cell--content actions-content">
                                    <div class="actions_wrap">
                                        <div v-if="!item.lock" class="ico del" @click="change_count(index,item.count, false, 0)" title="Удалить">
                                            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
                                                <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b_total">
                    Итого: {{ userStore.info.data.order_sum }}
                </div>
                <div class="buttons_wrap">
                    <div @click="route_to('Orders')" class="button_simple b_blue">Назад</div>
                    <a class="button_simple b_blue" title="Печать заказа" v-bind="{ href: '/api/1c/orders?id='+userStore.info.data.order_num+'&type=order_print' }" target="_blank">Печать</a>
                    <a class="button_simple b_blue" title="Печать счета" v-bind="{ href: '/api/1c/orders?id='+userStore.info.data.order_num+'&type=invoice_print' }" target="_blank">Счет</a>
                    <a class="button_simple b_blue" v-bind="{ href: '/b2b/generate_datamatrix/'+userStore.info.data.order_id }" target="_blank">Коды маркировки</a>


                    <div v-if="userStore.info.data.order_state==='Готов к обеспечению' || userStore.info.data.order_state==='Ожидается обеспечение'" @click="confirm_set(1)" class="button_simple b_blue">Отменить заказ</div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {useUserStore} from "@/stores/UserStore";
import loading from "@/components/support/loading";

export default {
    name: "order_info",
    components: {
        loading,
    },
    setup() {
        const userStore = useUserStore()
        return {
            userStore
        }
    },
    data: function () {
        return {
            page: {
                title: 'Ваш заказ',
                show_menu: false,
            }
        }
    },
    props: ['orderId', 'params'],
    methods: {
        confirm_set(set_var) {
            if (set_var === 1) {
                this.userStore.info.confirm = true;
                this.userStore.info.show = false;
            } else {
                this.userStore.info.confirm = false;
                this.userStore.info.show = true;
            }
        },
        remove_order() {
            this.userStore.info.confirm = false;
            this.userStore.info.show = false;
            this.$notifyInfo('Отменяем заказ');
            this.userStore.remove_order();
            //this.$router.push({ name: 'Orders' })
        },
        route_to(name) {
            this.$router.push({name: name})
        },
        change_count(uuid, count_now, vector, value) {
            //console.log(uuid,count_now, vector, value);
            // TODO: рефакторинг после заимствования из basket
            let new_count = 0;
            let enlarger = Number(value);
            if (vector === true) {
                new_count = Number(count_now) + enlarger;
            } else {
                new_count = Number(count_now) - enlarger;
            }
            let message = 'Запрос на измение кол-ва';
            if (value === 0 || new_count < 0) {
                new_count = 0;
                message = 'Запрос на удаление'
            }
            let add_arr = {
                'id': uuid,
                'uuid': uuid,
                'count': new_count,
            };
            this.$notifyInfo(message);
            this.userStore.change_count_in_order(add_arr).then(this.response_process);
        },
        update_orders() {
            this.userStore.fill_user_orders();
        },
        response_process(reqResult) {
            if (typeof (reqResult.type !== "undefined") && reqResult.type === 'success') {
                this.$notifySuccess(reqResult.message);
            } else if (typeof (reqResult.type !== "undefined") && reqResult.type === 'info') {
                this.$notifyInfo(reqResult.message);
            } else {
                this.$notifyError(reqResult.message);
            }
        }
    },
    created() {
        this.$emit('setPagesVars', this.page);
        this.userStore.info.show = true;
        this.userStore.info.cancel = false;
        this.userStore.fill_order_info(this.$route.params.orderId);
    },
}
</script>

<style scoped>
.add_ui {
    width: 133px;
    height: 38px;
    border: solid 1px #ADADAD;
    display: flex;
    flex-direction: row;
}

.add_ui .added {
    font-size: 24px;
    font-weight: bold;
    color: #174A8B;
    width: 40px;
    line-height: 28px;
    color: #659157;
    margin: 4px 0 0 0;
    text-align: center;
}

.add_ui .button {
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: bold;
    color: #ADADAD;
    text-align: center;
    border: solid 1px #FFF;
    cursor: pointer;
    margin: 5px 2px 0px 2px;
}

.add_ui .active, .add_ui .button:hover {
    border: solid 1px #ADADAD;
    color: #174A8B;
}

.o_info_error {
    margin: 50px 0 50px 0;
}

.confirm_wrap {
    margin: 50px 0 50px 0;
}

.buttons_wrap {
    display: flex;
    flex-direction: row;
    margin: 30px 0 50px 0;
}

.buttons_wrap .button_simple {
    margin: 0 10px 0 10px;
}

@media all and (max-width: 1200px) {
    .buttons_wrap {
        flex-direction: column;
    }

    .buttons_wrap .button_simple {
        margin: 0 10px 10px 10px;
    }
}

/* RTABLE start
==================================== */
* {
    box-sizing: border-box;
}

.wrapper {
    width: 100%;
    margin-bottom: 30px;
}

/* Table column sizing
================================== */
.title-cell {
    width: 24%;
    padding-left: 1%;
    margin-right: auto;
}

.articul-cell {
    width: 10%
}

.price-cell {
    width: 5%
}

.countui-cell {
    width: 140px
}

.summa-cell {
    width: 5%
}

.status-cell {
    width: 20%
}

.actions-cell {
    width: 5%
}

/* Apply styles
================================== */
.Rtable {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
}

.Rtable .Rtable-row {
    width: 100%;
    display: flex;
    border-bottom: 1px dashed #b7b7b7;
}

.Rtable .checked {
    background-color: #40769E;
}

.Rtable .Rtable-row .Rtable-cell {
    box-sizing: border-box;
    flex-grow: 1;
    overflow: hidden;
    list-style: none;
    line-height: 38px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.Rtable .Rtable-row .Rtable-cell.column-heading {
    background-color: #174A8B;
    color: white;
}

.Rtable .Rtable-row .Rtable-cell .Rtable-cell--heading {
    display: none;
}

.Rtable a {
    color: #174A8B;
    text-decoration: underline;
}

.Rtable a:hover {
    color: #174A8B;
    text-decoration: underline;
}

.Rtable .actions_wrap {
    display: flex;
    flex-direction: row;
}

.Rtable .actions_wrap .ico {
    display: block;
    width: 25px;
    height: 25px;
    margin-right: 20px;
    margin-top: 5px;
    cursor: pointer;
}

.Rtable .actions_wrap .ico svg {
    width: 25px;
    height: 25px;
    fill: #174A8B;
}

/* Responsive
==================================== */
@media all and (max-width: 1200px) {
    .Rtable--collapse {
        display: block;
        width: 100%;
        box-shadow: none;
    }

    .Rtable--collapse .Rtable-row {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 20px 0 20px 0;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell .Rtable-cell--heading {
        display: inline-block;
        flex: 1;
        max-width: 120px;
        min-width: 120px;
        color: #174A8B;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell .Rtable-cell--content {
        flex: 2;
    }

    .Rtable--collapse .title-cell {
        order: -1;
        padding-left: 0 !important;
    }

    .Rtable--collapse .title-cell .Rtable-cell--content {
        padding-left: 0 !important;
    }

    .Rtable--collapse .Rtable-row--head {
        display: none;
    }
}

.no-flexbox .Rtable {
    display: block;
}

.no-flexbox .Rtable.Rtable-cell {
    width: 100%;
}

/* RTABLE END
==================================== */
</style>
